export default __webpack_public_path__ + "static/media/1F.4c6431a1.png";